<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card max-width="600" grid-list-lg>
      <ModelTitle title="Receive advance tuition" @close="close()" />

      <v-card-text>
        <v-container class="pa-0" grid-list-lg>
          <v-card-text>
            <v-layout row wrap justify-space-between>
              <v-flex xs8>
                <div>Customer Name</div>
                <div class="font-weight-medium title text-capitalize">
                  {{ Customer.name }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div>Advance amount</div>
                <div class="font-weight-medium title">
                  {{ AdvancePayment.amount | currency }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap justify-space-between>

              <v-flex xs12 sm6>
                <v-select dense outlined :items="paymentMethods" v-model="AdvancePayment.paymentMethod" label="Payment Method"
                  item-text="name" hide-details return-object></v-select>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field type="number" dense outlined class="right-input" hide-details label="Amount received"
                  @focus="$event.target.select()" v-model="AdvancePayment.amount"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field dense outlined v-model="AdvancePayment.note" label="Memo" hide-details></v-text-field>
              </v-flex>

            </v-layout>
            <!-- <v-layout row wrap align-center v-if="Customer && Customer.payCompassId">
              <v-flex xs6>
                <v-checkbox class="ma-0 pa-0" v-model="collectedOnline" label="Collect Online" color="red"
                  :value="false" hide-details> </v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="collectedOnline">
                <v-select item-text="last4" return-object v-model="selectedCard" :loading="loadingCard" outlined dense
                  hide-details :items="cards" label="Select Card">
                  <template slot="item" slot-scope="{ item }">
                    <span>{{ item.last4 }}</span>
                    <v-spacer></v-spacer>
                    <span class="text-capitalize">{{ item.payment_method_type
                      }}</span>
                  </template></v-select>
              </v-flex>
            </v-layout> -->
          </v-card-text>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-checkbox v-if="!CustomerId" class="ma-0" v-model="AdvancePayment.donation" label="Donation Payment" color="red" :value="false"
          hide-details>
        </v-checkbox>
        <v-spacer></v-spacer>
        <v-btn color="info" text @click="close()">Close</v-btn>
        <v-btn color="info" :disabled="!AdvancePayment.amount ? true : false" :loading="loading" @click="submit()">{{
    AdvancePayment.amount
    | currency }} Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerService from "@/modules/Customer/service";
import paymentService from "../service";
import payCompassService from "@/modules/PayCompass/service.js";

export default {
  name: "create-advance-payment",
  props: {
    createDialog: {
      default: false,
    },
    CustomerId: {
      default: null,
    },
  },
  data() {
    return {
      collectResult: null,
      collectedOnline: false,
      loadingCard: false,
      loading: false,
      dialog: false,
      Customer: {
        name: null,
        balance: 0,
        localId: null,
      },
      cards: [],
      selectedCard: null,
      paymentMethods: [
        'Stripe',
        'Mohid',
        "Cash",
        "Check",
        "Paypal",
        "Debit Card",
        "Credit Card",
        "Wire",
        "Quick Pay",
        "Cash App",
        "Exchange",
        "Other",
      ],
      AdvancePayment: {
        CustomerId: 0,
        paymentMethod: "Cash",
        amount: 0,
        mohidId: null,
        stripeId: null,
        donation: false
      },
    };
  },
  watch: {
    collectedOnline(val) {
      if (val) {
        this.getCard(this.Customer.payCompassId)
      }
    },

    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getCustomer();
      }
    },
  },
  methods: {
    getCard(id) {
      payCompassService.getAllCard(id).then(response => {
        console.log('response', response)
        this.cards = response.data
        if (this.cards.length === 1) {
          this.selectedCard = this.cards[0]
        }
      })
    },
    getCustomer() {
      return customerService.getById(this.CustomerId).then((response) => {
        this.Customer = response.data;
        this.AdvancePayment.CustomerId = this.Customer.id;

        if (this.Customer?.mohidId) {
          this.AdvancePayment.mohidId = this.Customer.mohidId
          this.AdvancePayment.paymentMethod = 'Mohid'
        }
        if (this.Customer?.stripeId) {
          this.AdvancePayment.stripeId = this.Customer.stripeId
          this.AdvancePayment.paymentMethod = 'Stripe'
        }
        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.collectedOnline = false
      this.card = []
      this.AdvancePayment = {
        CustomerId: 0,
        paymentMethod: "Cash",
        PaymentDetails: [],
        mohidId: null,
        stripeId: null
      };
    },
    savePayment() {
      return paymentService
        .create(this.AdvancePayment)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Advance Payment was made",
              });
            this.loading = false;
            this.empty();
            this.$emit("submit");
            this.$events.emit("advancePaymentListEvent");
            this.$events.emit("customerProfileEvent");
            this.close();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    async collectPayment() {
      try {
        let amount = 0
        let description = 'Invoice # '
        this.AdvancePayment.PaymentDetails.map(row => {
          amount += row.amount
          description = description + row.localId + ', ' + row.id + ', '
        })
        let chargeObj = {
          amount: amount,
          description: description,
          source: this.selectedCard.id,
          customer: this.Customer.payCompassId,
          cardId: this.selectedCard.id,
          selectedInvoice: this.AdvancePayment.PaymentDetails
        }
        console.log('chargeObj', chargeObj)
        const paymentResponse = await payCompassService.chargeCustomerForMultipleInvoice(chargeObj)
        console.log('response payment', paymentResponse)
        if (paymentResponse && paymentResponse.data && paymentResponse.data.status_code === 'A') {
          this.AdvancePayment.referenceNumber = `${this.selectedCard.payment_method_type}-${this.selectedCard.last4}`
          this.AdvancePayment.PaymentDetails.map(row => {
            row.stripeChargeId = paymentResponse.data.reference_number
            row.metadata = paymentResponse.data
            // amount += row.amount
            // description = description + row.localId + ', ' + row.id + ', '
          })
          // this.AdvancePayment.PaymentDetails[0].stripeChargeId = paymentResponse.data.reference_number
          this.AdvancePayment.donation = false
          this.AdvancePayment.parent = true
          // this.AdvancePayment.PaymentDetails[0].metadata = paymentResponse.data
          return paymentResponse
        } else {
          this.$swal(response.data.status, response.data.error_message, 'error')
          this.loadingBtn = false
          return false
        }
      } catch (error) {
        console.log('error', error)
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
        return false
      }


    },
    async submit() {
      this.$swal({
        title: "Saving Advance Payment",
        text: `You are receiving ${this.$options.filters.currency(
          this.AdvancePayment.amount
        )}? `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.value) {
          console.log('payment', this.AdvancePayment)
          if (this.collectedOnline) {
            this.collectResult = await this.collectPayment()
            console.log('this.collectResult', this.collectResult)
            if (this.collectResult) {
              this.savePayment()
            }
          } else {
            this.savePayment()
          }
        }
      });

    },
  },
};
</script>

<style scoped></style>
